import axios, {
  AxiosError,
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
} from 'axios';

import { CustomNavigateProps } from '../../utils/types';
import { getHeaders } from '../services';

// Axios instance
const instance: AxiosInstance = axios.create({
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'x-lbg-business-context': 'O4B_REGISTRATION',
  },
  timeout: Number(process.env.API_TIMEOUT),
});

export const customInstance: AxiosInstance = axios.create({
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
  timeout: Number(process.env.API_TIMEOUT),
});

const generateHeaders = (
  config: AxiosRequestConfig,
  indicator: string,
): AxiosRequestConfig => ({
  ...config,
  headers: {
    ...config.headers,
    ...getHeaders(indicator),
  },
});

instance?.interceptors?.request.use((config: any): any => {
  let indicator = '';
  // Subscription key for sms-otp-init api
  if (
    config.url.includes('otp-verification') ||
    config.url.includes('access-token') ||
    config.url.includes('refresh-token')
  ) {
    indicator = 'SMS-OTP-SUBSCRIPTION-KEY';
  } else {
    indicator = 'OCP-APIM-SUBSCRIPTION-KEY';
  }

  return generateHeaders(config, indicator);
});

export const onError = (
  error: AxiosError,
  navigate: CustomNavigateProps,
): void => {
  let errData = { ...error };
  if (errData.response === undefined) {
    errData = { ...errData, response: { status: 500 } as AxiosResponse };
  }
  navigate('/error', {
    state: {
      status: errData.response.status || 500,
      statustext: errData.response.statusText,
    },
  });
};

export default instance;

export const SmsAuthzInstance: AxiosInstance = axios.create({
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': 'localhost:8081',
    'Access-Control-Allow-Credentials': 'true',
  },
  timeout: Number(process.env.API_TIMEOUT),
});

export const statusInstance: AxiosInstance = axios.create({
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': 'localhost:8081',
    'Access-Control-Allow-Credentials': 'true',
  },
  timeout: Number(process.env.API_TIMEOUT),
});

interface RetryConfig extends AxiosRequestConfig {
  retry: number;
  retryDelay: number;
}

export const retryConfig: RetryConfig = {
  retry: 3,
  retryDelay: 1000,
};
